import React from 'react'
import { connect } from 'react-redux';
import { dispatch } from 'rxjs/internal/observable/pairs';
import { dataType } from '@/constants/data-type';
import DataTable from '@/components/DataTable/DataTable';
import { userActions } from '@/actions/user';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY, REFRESH_DATA } from '@/constants/app';
import { utilsFunction, Converter, Comparator } from "@/helpers/functions";
import { PARAMS as requestParams } from '@/constants/params';
import { getPortfolioAction } from '@/actions/trading';
import Market_HK_Mobile from './Market_HK.mobile'
import Market_CN_Mobile from './Market_CN.mobile';
import MarketIndexMobile from './MarketIndex.mobile'
import classnames from 'classnames'


class MarketInfoMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        headTab:[
            { id: 1, title: 'market_hkex', value: 'HK' },
            { id: 2, title: 'market_stock_connect', value: 'CN' },
            { id: 3, title: 'market_funds', value: 'FUND' },
        ],
        currentTab: 'HK'
    }
    if(props.onRef){
      props.onRef(this)
    }
  }

  componentDidMount() {
    const { currentTradingAccount, token , profile , subTab} = this.props
  }


  refresh=(subTab,callback)=>{
    if(subTab === 'HK'){
      this.HKRef.getMostActiveStocks()
      this.HKRef.getGainers();
      this.HKRef.getLosers();
    } else if(subTab === 'CN'){
      this.CNRef.getMostActiveStocks_SH()
      this.CNRef.getMostActiveStocks_SZ()
      this.CNRef.getGainers_SH()
      this.CNRef.getGainers_SZ()
    }
    typeof callback === 'function' && callback()
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  
  render() {
    const { headTab, currentTab} = this.state;
    const { language, autoSize , subTab, innRef} = this.props;
    return (
      <div className="market-info-mobile">
        <div className='market-info-head'>
            {headTab.map(item => 
                <div key={item.id} onClick={() => this.setState({currentTab: item.value})} className={classnames(currentTab === item.value ? 'head-activation' : '')}>
                    {language[item.title]}
                </div>
            )}
        </div>
        <div className='market-info-container'>
            {currentTab === 'HK' && <Market_HK_Mobile/>}
            {currentTab === 'CN' && <Market_CN_Mobile/>}
        </div>
      </div>
    )
  }

}

// Watchlist.defaultProps = {
//   isFilter: false,
//   autoSize: true,
//   subTab : 'HK'
// }

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    mdsToken: state.trade.mdsToken,
    user: state.auth.user
  }),
  dispatch => ({
    // getWatchlist: (p, c) => dispatch(userActions.getWatchlistAction(p, c)),
    // getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    // getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    // setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    // toggleRefreshMarket: (p) => dispatch({
    //   type: REFRESH_DATA.MARKET_ACTION,
    //   value: p
    // }),
    // getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
  })
)(MarketInfoMobile)
